'use strict';

const listeners = new Set();

export function subscribeRematchClientMessages(listener) {
  if (typeof listener !== 'function') {
    throw new Error('subscribeRematchClientMessages: listener is required');
  }
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function emitRematchClientMessage(data) {
  if (!data || typeof data.type !== 'string') {
    throw new Error('emitRematchClientMessage: data.type is required');
  }
  for (const listener of listeners) {
    listener(data);
  }
}

let lastHandledMatchGameId = null;

export function shouldHandlePvpMatchFound(gameId) {
  if (!gameId) {
    throw new Error('shouldHandlePvpMatchFound: gameId is required');
  }
  if (lastHandledMatchGameId === gameId) {
    return false;
  }
  lastHandledMatchGameId = gameId;
  return true;
}
